import { demoPlaidLinkToken } from "./plaid-link-token";

export const plaidLinkTokenQuery = {
  read(_: any) {
    return demoPlaidLinkToken;
  },
};
